import { useState, useEffect } from "react";
import productdata from "../store/product.json";
import { useNavigate } from "react-router-dom";

const importAll = (r) => {
  let images = {};
  r.keys().forEach((item) => { 
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

// Import images from folders
const productImages = importAll(require.context("../../assets/product", false, /\.(png)$/));
const product1Images = importAll(require.context("../../assets/product1", false, /\.(png)$/));
const product1Images1 = importAll(require.context("../../assets/product2", false, /\.(png)$/));
const product1Images2 = importAll(require.context("../../assets/product3", false, /\.(png)$/));
const product1Images3 = importAll(require.context("../../assets/product4", false, /\.(png)$/));
const product1Images4 = importAll(require.context("../../assets/product5", false, /\.(png)$/));
const product1Images5 = importAll(require.context("../../assets/product6", false, /\.(png)$/));
const product1Images6 = importAll(require.context("../../assets/product7", false, /\.(png)$/));
const product1Images7 = importAll(require.context("../../assets/product8", false, /\.(png)$/));
const product1Images8 = importAll(require.context("../../assets/product9", false, /\.(png)$/));
const product1Images9 = importAll(require.context("../../assets/product10", false, /\.(png)$/));
const product1Images10 = importAll(require.context("../../assets/product11", false, /\.(png)$/));
const product1Images11 = importAll(require.context("../../assets/product12", false, /\.(png)$/));
const product1Images12 = importAll(require.context("../../assets/product13", false, /\.(png)$/));
const product1Images13 = importAll(require.context("../../assets/product14", false, /\.(png)$/));
const product1Images14 = importAll(require.context("../../assets/product15", false, /\.(png)$/));
const product1Images15 = importAll(require.context("../../assets/product16", false, /\.(png)$/));
const product1Images16 = importAll(require.context("../../assets/product17", false, /\.(png)$/));
const product1Images17 = importAll(require.context("../../assets/product18", false, /\.(png)$/));
const product1Images18 = importAll(require.context("../../assets/product19", false, /\.(png)$/));
const product1Images19 = importAll(require.context("../../assets/product20", false, /\.(png)$/));
const product1Images20 = importAll(require.context("../../assets/product21", false, /\.(png)$/));


const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [hoverImage, setHoverImage] = useState({}); // ← ADDED
  const navigate = useNavigate();

  useEffect(() => {
    setProducts(productdata);
  }, []);

  const showProduct = (id) => {
    navigate(`/product/${id}`);
  };

  const getImage = (folder, imgName) => {
    if (folder === "product") return productImages[imgName];
    if (folder === "product1") return product1Images[imgName];
    if (folder === "product2") return product1Images1[imgName];
    if (folder === "product3") return product1Images2[imgName];
    if (folder === "product4") return product1Images3[imgName];
    if (folder === "product5") return product1Images4[imgName];
    if (folder === "product6") return product1Images5[imgName];
    if (folder === "product7") return product1Images6[imgName];
    if (folder === "product8") return product1Images7[imgName];
    if (folder === "product9") return product1Images8[imgName];
    if (folder === "product10") return product1Images9[imgName];
    if (folder === "product11") return product1Images10[imgName];
    if (folder === "product12") return product1Images11[imgName];
    if (folder === "product13") return product1Images12[imgName];
    if (folder === "product14") return product1Images13[imgName];
    if (folder === "product15") return product1Images14[imgName];
    if (folder === "product16") return product1Images15[imgName];
    if (folder === "product17") return product1Images16[imgName];
    if (folder === "product18") return product1Images17[imgName];
    if (folder === "product19") return product1Images18[imgName];
    if (folder === "product20") return product1Images19[imgName];
    if (folder === "product21") return product1Images20[imgName];


    return null;
  };

  return (
    <>
      <div className="container-fluid" style={{ background: "linear-gradient(to right, #FFDA01, #f0a869ff)" }}>
        <div
          style={{
            height: "30vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <h1
            className="text-center"
            style={{ color: "black", fontWeight: "700" }}
          >
            HEALTHY & TASTY STORE PRODUCTS
          </h1>
        </div>

        <div className="container">
          <div className="row">
            {products.map((item) => (
              <div className="col-md-4 mb-5" key={item.id}>
                <div
                  className="card p-2"
                  style={{ cursor: "pointer", boxShadow:'5px 5px gray' }}
                  onClick={() => showProduct(item.id)}

                  // ⭐ HOVER LOGIC ADDED BELOW ⭐
                  onMouseEnter={() =>
                    setHoverImage(prev => ({ ...prev, [item.id]: true }))
                  }
                  onMouseLeave={() =>
                    setHoverImage(prev => ({ ...prev, [item.id]: false }))
                  }
                >
                  <img
                    src={
                      hoverImage[item.id]
                        ? getImage(item.folder, item.image[1]) // ← show hover image
                        : getImage(item.folder, item.image[0]) // ← show normal image
                    }
                    alt={item.name}
                    style={{
                      width: "100%",
                      height: "400px",
                      objectFit: "cover",
                      transition: "0.3s ease", // smooth effect
                    }}
                  />

                  <h5
                    className="mt-2"
                    style={{
                      color: "black",
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    {item.name}
                  </h5>

                  <div className="d-flex" style={{ gap: "10px" }}>
                    <p
                      style={{
                        color: "black",
                        fontWeight: "700",
                        fontSize: "20px",
                      }}
                    >
                      ₹{item.discounted}
                    </p>
                    <p
                      style={{
                        color: "black",
                        fontWeight: "700",
                        fontSize: "20px",
                        textDecoration: "line-through",
                      }}
                    >
                      ₹{item.price}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPage;
